export const SET_BUNKEY_HOST = "SET_BUNKEY_HOST"
export const CLOSE_BUNKEY_HOST = "CLOSE_BUNKEY_HOST"